import axiosInstance, { getApiUrl, ApiKeys } from '@cp/src/utils/ApiHelper';
import { Dispatch } from 'react';
import { setUploadHistory, setAmeyoGuidelines, setPreSignedUrl } from './reducer/ameyoUtilitySlice';
import { isFunction } from '@cp/src/utils/commonUtils';
import { getFileDownload } from '@cp/src/utils/commonUtils';
import { AxiosError } from 'axios';
import { UploadFileResponse } from './types';
import { API_STATUS_CODE } from '@cp/src/utils/ApiHelperUtils';

export const fetchUploadHistory = (
  pageNo: number,
  pageSize: number,
  sortBy: string,
  sortDirection: string,
  loadingCb?: (loading: boolean) => void
) => {
  const url = getApiUrl(ApiKeys.AMEYO_UTILITY_UPLOAD_HISTORY);
  if (isFunction(loadingCb)) {
    loadingCb(true);
  }
  return (dispatch: Dispatch<any>) => {
    axiosInstance
      .get(url, {
        params: { pageNo, pageSize, sortBy, sortDirection }
      })
      .then(response => {
        if (response) {
          dispatch(setUploadHistory(response?.data));
          if (isFunction(loadingCb)) {
            loadingCb(false);
          }
        }
      });
  };
};

export const fetchUploadHistoryPolling = (
  pageNo: number,
  pageSize: number,
  sortBy: string,
  sortDirection: string
) => {
  const url = getApiUrl(ApiKeys.AMEYO_UTILITY_UPLOAD_HISTORY);
  return axiosInstance.get(url, {
    params: { pageNo, pageSize, sortBy, sortDirection }
  });
};

export const fetchFile = (fileReferenceId: string, value: string) => {
  const url = getApiUrl(ApiKeys.AMEYO_UTILITY_DOWNLOAD_FILE);
  return (dispatch: Dispatch<any>) => {
    axiosInstance
      .get(url, {
        params: { fileReferenceId, value }
      })
      .then(response => {
        if (response) {
          const fileUrl = response?.data?.data;
          getFileDownload(fileUrl);
        }
      });
  };
};

export const fetchSampleFile = () => {
  const url = getApiUrl(ApiKeys.AMEYO_UTILITY_DOWNLOAD_SAMPLE_FILE);
  return (dispatch: Dispatch<any>) => {
    axiosInstance.get(url).then(response => {
      if (response?.data) {
        const fileUrl = response?.data?.data;
        getFileDownload(fileUrl);
      }
    });
  };
};

export const uploadFile = async (
  file: File | null,
  purge: boolean
): Promise<UploadFileResponse | null> => {
  if (!file) {
    return Promise.reject('No file provided for upload.');
  }
  const url = getApiUrl(ApiKeys.AMEYO_UTILITY_UPLOAD_TO_AMEYO);

  const formData = new FormData();
  formData.append('file', file);
  formData.append('purge', purge ? 'true' : 'false');

  try {
    const response = await axiosInstance.post(url, formData, {
      headers: { donotHandleError: true }
    });
    if (response.status === API_STATUS_CODE.ACCEPTED) {
      return { success: true, message: '', error: false };
    } else return { error: true, message: response.data.title, success: false };
  } catch (error) {
    if (error instanceof AxiosError) {
      return { error: true, message: error?.response?.data?.title, success: false };
    }
  }
  return null;
};

export const fetchGuidelines = () => {
  const url = getApiUrl(ApiKeys.AMEYO_UTILITY_GUIDELINES);
  return (dispatch: any) => {
    axiosInstance.get(url).then(response => {
      if (response) {
        dispatch(setAmeyoGuidelines(response?.data?.data));
      }
    });
  };
};
